<div
  *ngIf="(type || config) && control"
  [class.dark-theme-color]="(currentThemeSubject | async) === 'dark'"
  [class.light-theme-color]="(currentThemeSubject | async) === 'light'"
>
  <ng-container [ngSwitch]="type || config?.type">
    <ng-container *ngSwitchCase="editorFieldTypeEnum.TEMPLATE">Field type should be changed</ng-container>
    <input *ngSwitchCase="editorFieldTypeEnum.HIDDEN" type="hidden" [formControl]="control" />
    <mat-checkbox
      *ngSwitchCase="editorFieldTypeEnum.CHECKBOX"
      class="ml-12"
      color="primary"
      [class.readonly]="readonly || config?.readonly"
      [formControl]="control"
      [required]="config?.required"
      [fbDisableControl]="disabled || readonly || config?.readonly || config?.disabled"
      [labelPosition]="config?.labelPosition || 'after'"
    >
      {{ config?.label }}
    </mat-checkbox>
    <fb-data-select
      *ngSwitchCase="editorFieldTypeEnum.SELECT_DATA"
      [formControl]="control"
      [label]="label || config?.label"
      [placeholder]="placeholder || config?.placeholder"
      [options]="options || config?.options || (config?.options$ | async)"
      [multiple]="multiple || config?.multiple"
      [selectAll]="config?.selectAll"
      [required]="required || config?.required"
      [disable]="disabled || readonly || config?.readonly || config?.disabled"
      [noLabel]="config?.noLabel"
      [templates]="templates"
      [currentThemeSubject]="currentThemeSubject | async"
    ></fb-data-select>

    <fb-upload-file-list-field
      *ngSwitchCase="editorFieldTypeEnum.FILE_LIST"
      [formControl]="control"
      [multiple]="config?.multiple"
      [caption]="config?.label"
      [config]="config"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [currentThemeSubject]="currentThemeSubject | async"
    ></fb-upload-file-list-field>
    <fb-data-radio
      *ngSwitchCase="editorFieldTypeEnum.RADIO"
      [formControl]="control"
      [options]="options || config?.options || (config?.options$ | async)"
      [dataStorage]="dataStorage || config?.dataStorage"
      [required]="config?.required"
      [readonly]="config?.readonly"
      [disable]="disabled"
    ></fb-data-radio>
    <fb-checkbox-list-field
      *ngSwitchCase="editorFieldTypeEnum.CHECKBOX_LIST"
      [formControl]="control"
      [options]="options || config?.options || (config?.options$ | async)"
      [required]="config?.required"
      [readonly]="config?.readonly"
      [cssClass]="config?.cssClass"
      [disable]="disabled"
    ></fb-checkbox-list-field>
    <ng-container *ngSwitchCase="editorFieldTypeEnum.TIME">
      <mat-form-field [appearance]="defaultAppearance" [floatLabel]="'always'" class="w-full">
        <mat-label>{{ config?.label }}</mat-label>
        <fb-timepicker-field
          [config]="config"
          [formControl]="control"
          [required]="config?.required || false"
          [disable]="disabled"
          [readonly]="readonly || config?.readonly"
        ></fb-timepicker-field>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="editorFieldTypeEnum.TIME2">
      <div class="fb-default-field-wrapper w-full">
        <div class="fb-field-label-container" *ngIf="!config?.noLabel">
          <label
            class="fb-field-label"
            *ngIf="config?.label"
            [class.disable-label]="disabled && (_currentThemeSubject | async) === 'dark'"
          >
            {{ config?.label }}
            <span class="required-asterisk" *ngIf="required || config?.required">*</span>
          </label>
        </div>

        <mat-form-field
          [appearance]="defaultAppearance || 'outline'"
          floatLabel="always"
          class="w-full fb-custom-outline time-picker-field"
          [class.is-invalid]="control.invalid && (control.touched || control.dirty)"
          [class.is-filled]="control.value"
        >
          <fb-timepicker2-field
            [config]="config"
            [formControl]="control"
            [required]="config?.required || false"
            [apmMode]="config?.apmMode || false"
            [limitTimeAfterPaste]="config?.limitTimeAfterPaste"
            [xAnchor]="config?.xAnchor || undefined"
            [disabled]="disabled"
            [readonly]="readonly || config?.readonly"
            [currentThemeSubject]="currentThemeSubject | async"
          ></fb-timepicker2-field>
        </mat-form-field>

        <div class="fb-field-subscript-absolute">
          <fb-validation-error
            *ngIf="control.invalid && (control.touched || control.dirty)"
            [control]="control"
            [label]="config?.label"
            [themeMode]="currentThemeSubject | async"
          ></fb-validation-error>
        </div>
      </div>
    </ng-container>
    <fb-number-field
      *ngSwitchCase="editorFieldTypeEnum.CURRENCY"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [min]="config?.min !== undefined ? config?.min : min"
      [max]="config?.max !== undefined ? config?.max : max"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix || { type: 'text', text: '$' }"
      [suffix]="config?.suffix"
      [digitsCount]="config?.digitsCount || 2"
      [templates]="templates"
    ></fb-number-field>
    <fb-number-field
      *ngSwitchCase="editorFieldTypeEnum.PERCENT"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [min]="config?.min !== undefined ? config?.min : min"
      [max]="config?.max !== undefined ? config?.max : max"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix"
      [suffix]="config?.suffix || { type: 'text', text: '%' }"
      [digitsCount]="config?.digitsCount || 2"
      [templates]="templates"
    ></fb-number-field>
    <fb-number-field
      *ngSwitchCase="editorFieldTypeEnum.NUMBER"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [minlength]="config?.minLength !== undefined ? config?.minLength : minLength"
      [maxlength]="config?.maxLength !== undefined ? config?.maxLength : maxLength"
      [min]="config?.min !== undefined ? config?.min : min"
      [max]="config?.max !== undefined ? config?.max : max"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix"
      [suffix]="config?.suffix"
      [templates]="templates"
      [digitsCount]="config?.digitsCount"
      [useCommaSeparator]="config?.useCommaSeparator"
    ></fb-number-field>
    <fb-password-field
      *ngSwitchCase="editorFieldTypeEnum.PASSWORD"
      [appearance]="defaultAppearance"
      [noLabel]="config.noLabel"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [minLength]="config?.minLength !== undefined ? config?.minLength : minLength"
      [maxLength]="config?.maxLength !== undefined ? config?.maxLength : maxLength"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix"
      [suffix]="config?.suffix"
      [passwordRequirements]="config?.passwordRequirements"
      [templates]="templates"
    ></fb-password-field>
    <fb-date-range-field
      *ngSwitchCase="editorFieldTypeEnum.DATE_RANGE"
      [appearance]="defaultAppearance"
      [noLabel]="config.noLabel"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [withNoResetDateRange]="config.withNoResetDateRange"
      [currentThemeSubject]="currentThemeSubject | async"
      min="{{ config?.min !== undefined ? config?.min : min }}"
      max="{{ config?.max !== undefined ? config?.max : max }}"
      [maxDate]="config?.maxDate"
    ></fb-date-range-field>
    <fb-date-field
      *ngSwitchCase="editorFieldTypeEnum.DATE"
      [controls]="config?.controls"
      [appearance]="defaultAppearance"
      [noLabel]="config.noLabel"
      [label]="config?.label"
      [mask]="config?.mask"
      [specialCharacters]="config?.specialCharacters"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [minlength]="config?.minLength !== undefined ? config?.minLength : minLength"
      [maxlength]="config?.maxLength !== undefined ? config?.maxLength : maxLength"
      [min]="config?.min !== undefined ? config?.min : min"
      [max]="config?.max !== undefined ? config?.max : max"
      [maxDate]="config?.maxDate"
      [timezone]="config?.timezone"
      [required]="required || config?.required"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix"
      [withArrows]="config?.withArrows"
      [withReset]="config?.withReset"
      [templates]="templates"
      [currentThemeSubject]="currentThemeSubject | async"
    ></fb-date-field>
    <fb-phone-field
      *ngSwitchCase="editorFieldTypeEnum.PHONE"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [disable]="disabled || config?.disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix"
      [suffix]="config?.suffix"
      [templates]="templates"
      [phonePrefix]="config?.phonePrefix === undefined ? '1' : config?.phonePrefix"
      [mask]="config?.mask"
      [noLabel]="config.noLabel"
    ></fb-phone-field>
    <fb-color-field
      *ngSwitchCase="editorFieldTypeEnum.COLOR"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
    ></fb-color-field>
    <fb-number-range-field
      *ngSwitchCase="editorFieldTypeEnum.NUMBER_RANGE"
      [controls]="config?.controls"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [mask]="config?.mask"
      [specialCharacters]="config?.specialCharacters"
      [placeholder]="config?.placeholder"
      [formControl]="control"
      [required]="required || config?.required"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [suffix]="config?.suffix"
      [templates]="templates"
    ></fb-number-range-field>
    <fb-rating-field
      *ngSwitchCase="editorFieldTypeEnum.RATING"
      [formControl]="control"
      [disable]="disabled"
    ></fb-rating-field>
    <fb-data-autocomplete
      *ngSwitchCase="editorFieldTypeEnum.DATA_AUTOCOMPLETE"
      [noLabel]="config.noLabel"
      [appearance]="defaultAppearance"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [required]="required || config?.required"
      class="w-full"
      [formControl]="control"
      [storage]="config?.storage"
      [storageParams]="config?.storageParams"
      [valueToString]="config?.valueToString"
      [createNew]="config?.createNew"
      [optionTemplate]="config?.optionTemplate || (config?.optionTemplate$ | async)"
      [prefix]="config?.prefix"
      [suffix]="config?.suffix"
      [templates]="templates"
      [notFoundMessage]="config?.notFoundMessage || 'Data not found'"
      [addButtonCaption]="config?.addButtonCaption || 'Add New'"
      [allowEmpty]="config?.allowEmpty !== undefined ? config?.allowEmpty : true"
      [allowCreate]="config?.allowCreate !== undefined ? config?.allowCreate : false"
      [alwaysNewSearch]="config?.alwaysNewSearch !== undefined ? config?.alwaysNewSearch : false"
      [emitEventWhenLoadedById]="config?.emitEventWhenLoadedById || false"
      [disable]="disabled || config?.disabled"
      [disabledItems]="disabledItems"
      [readonly]="readonly || config?.readonly"
      [loading]="loading"
      [transformSelected]="config?.transformSelected"
      [currentThemeSubject]="currentThemeSubject | async"
      [clearValueAfterSelect]="config.clearValueAfterSelect"
    ></fb-data-autocomplete>
    <fb-select-autocomplete
      *ngSwitchCase="editorFieldTypeEnum.SELECT_AUTOCOMPLETE"
      [appearance]="defaultAppearance"
      [noLabel]="config.noLabel"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [required]="required || config?.required"
      [options]="options || config?.options || (config?.options$ | async)"
      [groupedOptions]="config?.groupedOptions"
      class="w-full"
      [formControl]="control"
      [allowEmpty]="config?.allowEmpty !== undefined ? config?.allowEmpty : true"
      [disable]="disabled || config.disabled"
      [readonly]="readonly || config?.readonly"
      [prefix]="config?.prefix"
      [suffix]="config?.suffix"
      [templates]="templates"
    ></fb-select-autocomplete>
    <fb-upload-field
      *ngSwitchCase="editorFieldTypeEnum.FILE"
      [formControl]="control"
      [multiple]="config?.multiple"
      [caption]="config?.label"
      [config]="config"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
      [currentThemeSubject]="currentThemeSubject | async"
    ></fb-upload-field>
    <fb-document-upload-field
      *ngSwitchCase="editorFieldTypeEnum.DOCUMENT_UPLOAD"
      [formControl]="control"
      [caption]="config?.label"
      [config]="config"
    ></fb-document-upload-field>
    <fb-image-slider-field
      *ngSwitchCase="editorFieldTypeEnum.IMAGE_SLIDER"
      [formControl]="control"
      [showMainImage]="config?.showMainImage"
      [numberOfImages]="config?.numberOfImages"
      [slideWidth]="config?.slideWidth"
      [caption]="config?.label"
      [showSlider]="config?.showSlider"
      [config]="config"
    ></fb-image-slider-field>
    <fb-ios-toggle
      *ngSwitchCase="editorFieldTypeEnum.IOS_TOGGLE"
      [formControl]="control"
      [config]="config"
      [currentThemeSubject]="currentThemeSubject | async"
    ></fb-ios-toggle>
    <fb-email-list-field
      *ngSwitchCase="editorFieldTypeEnum.EMAIL_LIST"
      [label]="config?.label"
      [placeholder]="config?.placeholder"
      [appearance]="defaultAppearance"
      [formControl]="control"
      [required]="config?.required"
      [disable]="disabled"
      [readonly]="readonly || config?.readonly"
    ></fb-email-list-field>
    <div
      *ngSwitchCase="editorFieldTypeEnum.ON_OFF"
      class="d-flex flex-direction-column align-items-center justify-content-center"
    >
      <span class="on-off-label">{{ label || config?.label || (config?.name | titlecase) }}</span>
      <div class="on-off-text d-flex align-items-center">
        <label [attr.for]="toggle.inputId" class="cursor-pointer mr-8">Off</label>
        <mat-slide-toggle #toggle color="primary" [formControl]="control">On</mat-slide-toggle>
      </div>
    </div>
    <div *ngSwitchDefault class="fb-default-field-wrapper w-full">
      <div class="fb-field-label-container" *ngIf="!config?.noLabel">
        <label class="fb-field-label" *ngIf="config?.label">
          {{ config?.label }}
          <span class="required-asterisk" *ngIf="required || config?.required">*</span>
        </label>
      </div>

      <mat-form-field
        [appearance]="defaultAppearance"
        class="w-full fb-custom-outline"
        [class.text-area]="type || config?.type === editorFieldTypeEnum.TEXT_AREA"
        [class.is-invalid]="control.invalid && (control.touched || control.dirty)"
        [class.is-filled]="control.value"
      >
        <fb-anex
          *ngIf="config?.prefix"
          matPrefix
          [config]="config?.prefix"
          [control]="control"
          [templates]="templates"
          position="start"
        ></fb-anex>

        <ng-container [ngSwitch]="type || config?.type">
          <input
            *ngSwitchCase="editorFieldTypeEnum.EMAIL"
            matInput
            type="email"
            fbDisableAutocomplete
            minlength="{{ minLength || config?.minLength }}"
            maxlength="{{ maxLength || config?.maxLength }}"
            [formControl]="control"
            [placeholder]="config?.placeholder"
            [required]="required || config?.required"
            [fbDisableControl]="disabled || config.disabled"
            [readonly]="readonly || config?.readonly"
          />
          <input
            *ngSwitchCase="editorFieldTypeEnum.MASK"
            matInput
            type="string"
            fbDisableAutocomplete
            [mask]="config?.mask"
            [definitions]="config?.definitions"
            [dropSpecialCharacters]="config?.dropSpecialCharacters"
            [formControl]="control"
            [placeholder]="config?.placeholder"
            [required]="required || config?.required"
            [patterns]="(config?.pattern | maskToPattern) || (config?.definitions | maskToDefinitionsPipe)"
            [fbDisableControl]="disabled || config.disabled"
            [readonly]="readonly || config?.readonly"
          />
          <div class="w-full" *ngSwitchCase="editorFieldTypeEnum.TEXT_AREA">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="{{ config?.textAreaRows || 6 }}"
              cdkAutosizeMaxRows="10"
              [formControl]="control"
              fbDisableAutocomplete
              [placeholder]="config?.placeholder"
              [required]="required || config?.required"
              [fbDisableControl]="disabled"
              [readonly]="readonly || config?.readonly"
              minlength="{{ minLength || config?.minLength }}"
              maxlength="{{ maxLength || config?.maxLength }}"
              (focusout)="trimStringValue()"
            ></textarea>
          </div>
          <input
            *ngSwitchDefault
            matInput
            fbDisableAutocomplete
            minlength="{{ minLength || config?.minLength }}"
            maxlength="{{ maxLength || config?.maxLength }}"
            [formControl]="control"
            [placeholder]="config?.placeholder"
            [required]="required || config?.required"
            [fbDisableControl]="disabled"
            [readonly]="readonly || config?.readonly"
            [patterns]="config?.pattern | maskToPattern"
            [mask]="config?.pattern ? '0*' : undefined"
            (focusout)="trimStringValue()"
            (focus)="focusEmit.emit()"
            (blur)="blurEmit.emit()"
          />
        </ng-container>

        <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
          <ng-container *ngIf="config?.suffix; else showClearButton">
            <fb-anex
              matSuffix
              [style.margin-right.px]="0"
              [config]="config?.suffix"
              [control]="control"
              [templates]="templates"
              position="end"
            ></fb-anex>
          </ng-container>
          <ng-template #showClearButton>
            <button
              *ngIf="control.value && !disabled && !config.readonly"
              tabindex="-1"
              type="button"
              matSuffix
              mat-icon-button
              [disabled]="disabled || readonly || config?.readonly"
              (click)="clear()"
            >
              <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
            </button>
          </ng-template>
        </ng-container>
        <ng-template #showLoader>
          <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
        </ng-template>
      </mat-form-field>

      <div class="fb-field-subscript-absolute">
        <fb-validation-error
          *ngIf="control.invalid && (control.touched || control.dirty) && (loading.active$ | async) === false"
          [control]="control"
          [label]="label"
          [themeMode]="currentThemeSubject | async"
        ></fb-validation-error>

        <span class="fb-help-text" *ngIf="config?.helpText && !(control.invalid && (control.touched || control.dirty))">
          {{ config?.helpText }}
        </span>
      </div>
    </div>
  </ng-container>
</div>
